import 'videojs-contrib-ads';
import 'videojs-ima';
import toString from 'lodash/toString';
import { getDeviceName, isMobile } from '../util/mobile-detect';
import { getOpenRTBValue } from '../util/openRTB';
import sitenameFromUrl from '../util/sitenameFromUrl';
import personalAdConsent from '../util/personalAdConsent';

const formatString = value =>
  toString(value)
    .toLowerCase()
    .replace(/[^a-z]/g, '');

const getSiteName = () => {
  const params = new URLSearchParams(document.location.search);
  return params.get('siteName') || sitenameFromUrl(document.referrer);
};

const deviceNameRTB = getOpenRTBValue(getDeviceName());
const site = getSiteName();

const getIdentifier = () => {
  const device = isMobile() ? 'smartphone' : 'desktop';
  return `${site}-${device}`;
};

// Without consent, ncc needs to be 'true', with consent it needs to be 'false'.
// Because this logic causes confusion, we flip the original value from `cookiePersonalAdsConsent`, .
// Documentation about this: https://adconfig.ster.nl/documentation
const getNoCookieConsent = () => (!personalAdConsent()).toString();

const getCustomParameters = playerProps => {
  const customParameters = {
    net: playerProps.video,
    site,
    omroep: playerProps.broadcasters,
    player: isMobile() ? 'mobiel' : 'web',
    devicetype: deviceNameRTB,
    genre: playerProps.genres.length ? playerProps.genres.join(',') : null,
    referrer_url: document.referrer || document.location.href,
    afleverings_titel: formatString(playerProps.title),
    programma_titel: formatString(playerProps.programTitle),
    video_duur: playerProps.duration,
  };

  const params = new URLSearchParams();
  Object.keys(customParameters).forEach(key => {
    const value = customParameters[key];
    if (value) {
      params.set(key, value);
    }
  });

  return params.toString();
};

/**
 *
 * @param config
 * @param media
 * @returns {string}
 */
export const createTagUrl = (adUrl, playerProps) => {
  const adTagURL = new URL(adUrl);

  const custParams = getCustomParameters(playerProps);
  adTagURL.searchParams.set('ncc', getNoCookieConsent());
  adTagURL.searchParams.set('cust_params', custParams);

  return adTagURL.toString();
};

export default {
  mapPropStateToOptions: async (props, state) => {
    try {
      const sterConfigUrl = createTagUrl(
        `https://adconfig.ster.nl/adurl/${getIdentifier()}`,
        props
      );

      const response = await fetch(sterConfigUrl);
      const { adUrl: adTagUrl } = await response.json();

      return {
        id: state.nodeId,
        adTagUrl,
        adTag: 'Ad',
        adLabel: 'Advertenties',
        adLabelNofN: 'van',
      };
    } catch (error) {
      return {};
    }
  },
};
